export const PHONE_PICKER_TYPES = {
  brand: "brand",
  brands: "brands",
  popular: "popular",
  searchBlur: "searchBlur",
  searchFocus: "searchFocus"
};

export const PHONE_PICKER_ITEMS_PER_PAGE = 12;
